{
    "UploadfilesFilename": "Nom du fichier",
    "UploadfilesFilesize": "Taille du fichier",
    "UploadfilesEmailserroredsendingseebelow": "Cliquez pour plus d'informations",
    "UploadfilesSuccesswitherrorparagraph": "Vos utilisateurs ont été configurés. Cependant, il y a eu une erreur dans l'envoi des emails de bienvenue.",
    "Resulttableheaderusername": "Nom d'utilisateur :",
    "Resulttableheaderemail": "Adresse électronique",
    "Resulttableheaderrptaccess": "Accès aux rapports",
    "Resulttableheaderisadmin": "C'est Admin ?",
    "Resulttableheaderisocagent": "Est-ce que OC Agent ?",
    "Resulttableheaderenhancemobileapp": "Une application mobile améliorée ?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Téléchargement en masse d'utilisateurs",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Fichier d'importation.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Début",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Traitement.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Dos",
    "LanguageBulkInsertUsers_UploadfilesButton3": "Confirmer",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importation.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Oups.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Confirmation.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Le succès.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Terminé",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Hourra ! Nous avons configuré vos utilisateurs avec succès.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Commencez par télécharger et remplir le",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "Modèle CSV",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "fourni.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Confirmez que tout a été correctement saisi et procédez ensuite à l'importation du fichier complété ici (Toute erreur dans le fichier sera détectée lors de la configuration) :",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Choisir le fichier",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": " ou glisser-déposer ici.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Déposez vos fichiers ici...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Détails du dossier :",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Êtes-vous sûr de vouloir fermer la fenêtre et perdre la progression ?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Oui",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Annuler",
    "LanguageBulkInsertUsers_ValidationError": "Erreur : Nous n'avons pas pu traiter la demande d'approvisionnement en gros. Voir ci-dessous pour plus d'informations.",
    "LanguageBulkInsertUsers_SuccessTitle": "Veuillez vérifier vos modifications et confirmer.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Erreur : Format de fichier non valide, veuillez utiliser notre modèle CSV.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Erreur : La taille maximale du fichier est dépassée. Maximum 10 MB autorisé.",
    "NAME": "LanguageBulkInsertUsers"
}